module.exports = __webpack_public_path__ + "static/media/Merriweather-Regular.fa69aefa.ttf";